import type { FunctionComponent, TargetedKeyboardEvent } from 'preact';

import type { TemplateFunction } from 'Components/types';
import { vehicleSelectionSelector } from 'Core/selectors/fitmentSearch/index';
import { useSelector } from 'Core/store';
import type { AutocompleteItemParams } from 'Models/autocompleteItem';
import type { AutocompleteItem } from 'Models/index';
import { cloneSafe } from 'Utils/components';
import { toKebabCase } from 'Utils/string';

export type Params = {
  template: string;
  query?: string;
} & AutocompleteItemParams;

export type AutocompleteItemHandlers = {
  onClickHandler: (item: AutocompleteItem) => void;
  onMouseOverHandler?: (item: AutocompleteItem) => void;
};

export type Props = {
  template: TemplateFunction<Params>;
  item: AutocompleteItem;
  query?: string;
  templateName: string;
} & AutocompleteItemHandlers;

const DropdownItem: FunctionComponent<Props> = ({
  template,
  item,
  query,
  templateName,
  onClickHandler,
  onMouseOverHandler,
}) => {
  const vehicleSelection = useSelector(vehicleSelectionSelector);

  const props = {
    appendedClasses: `item ${toKebabCase(templateName)}-item nav-item`,
    tabIndex: -1,
    onClick: () => onClickHandler(item),
    onMouseOver: () => onMouseOverHandler?.(item),
    onKeyDown: (e: TargetedKeyboardEvent<HTMLElement>) => {
      if (e.key === 'Enter') {
        e.stopPropagation();
        onClickHandler(item);
      }
    },
  };

  const component = template.call({
    ...item.getParams(vehicleSelection),
    template: templateName,
    query,
  });
  return cloneSafe(component, null, props);
};
export default DropdownItem;
